import { isEmpty } from 'ui-seeker/utils'
import { USER_ROLE } from 'app/@common/constants'
import { useAppScrollListener, useSetHotel } from 'app/@hooks';
import { useContextSelector } from 'use-context-selector'
import { AppDatesContext, AppMainHotelsContext } from 'app/providers'
import { getAppUserData } from 'app/@utils'


export default function useAppMainHotelSelector(feature) {

    const scroll = useAppScrollListener()
    const updateMainHotels = useContextSelector(AppMainHotelsContext, ({updateState}) => updateState)
    const mainHotels = useContextSelector(AppMainHotelsContext, ({state}) => state.mainHotels)
    const mainHotelsLabel = useContextSelector(AppMainHotelsContext, ({state}) => state.mainHotelsLabel)
    const isChangingHotel = useContextSelector(AppMainHotelsContext, ({state}) => state.isChangingHotel)
    const { role, mainHotelsSectionData, uidSlave, userId, selectedMainHotel } = getAppUserData()
    const isUserMaster = role === USER_ROLE.MASTER
    const userInfoData = mainHotelsSectionData ? mainHotelsSectionData[isUserMaster ? parseInt(uidSlave) : userId] : null
    const idMainHotel = userInfoData && !isEmpty(userInfoData[feature]) ? userInfoData[feature]?.idHotel[0] : null
    const numMonths = useContextSelector(AppDatesContext, ({state}) => state.numMonths)
    const isMultiHotel = userInfoData ? userInfoData[feature]?.isMulti : null
    const { setHotel } = useSetHotel()

    const onChange = (idHotel, label = null) => {
        if (idHotel === null) {
            if (selectedMainHotel) {
                localStorage.setItem('packagesLastMainHotel', selectedMainHotel)
            }
            localStorage.setItem('packagesAllHotelsMode', 'true')
            // Persist the "All hotels" label so the fallback also propagates in this mode.
            // If the caller didn't pass a label, keep whatever was cached previously.
            if (label) localStorage.setItem('selectedMainHotelLabel', label)
            updateMainHotels({ mainHotels: null, forceRemount: Date.now(), isChangingHotel: true, ...(label && { mainHotelsLabel: label }) })
            return
        }
        const wasAllMode = localStorage.getItem('packagesAllHotelsMode') === 'true'
        localStorage.removeItem('packagesAllHotelsMode')
        if (idHotel?.toString() === selectedMainHotel && !wasAllMode) return
        // Optimistic visual feedback + lock until finalizeDefaults clears it in useDefault.js.
        // Persist label so F5 and re-fetches keep showing the hotel name in the selector.
        // If the caller didn't pass a label, keep whatever was cached previously (don't overwrite).
        if (label) localStorage.setItem('selectedMainHotelLabel', label)
        updateMainHotels({ mainHotels: idHotel, isChangingHotel: true, ...(label && { mainHotelsLabel: label }) })
        setHotel(idHotel, { remount: true }).catch(e => console.error('ERROR', e))
    }

    const onInit = idHotel => {
        updateMainHotels({ mainHotels: idHotel })
        if (idHotel && idHotel?.toString() !== selectedMainHotel) {
            setHotel(idHotel).catch(e => console.error('ERROR', e))
        }
    }

    return {
        scroll: scroll.y,
        onChange, onInit, setHotel, updateMainHotels, mainHotels, mainHotelsLabel, idMainHotel, selectedMainHotel, isUserMaster, numMonths, isMultiHotel, isChangingHotel
    }
}